import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueCurrencyInput from 'vue-currency-input'
import App from './App.vue'
import router from './router'
import store from './store'
import { extend, localize } from 'vee-validate'
import de from 'vee-validate/dist/locale/de.json'
import * as rules from 'vee-validate/dist/rules'

import './assets/scss/main.scss'
Vue.use(BootstrapVue)

Vue.use(VueCurrencyInput)

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
localize('de', de)

const requireBasicComponents = require.context(
  './components/BaseComponents', false, /Basic[A-Z]\w+\.vue$/
)
requireBasicComponents.keys().forEach(fileName => {
  const componentConfig = requireBasicComponents(fileName)
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
